const env = $ADMIN_BASE_ENV;
let isOa = false;
if (env === 'test' || env === 'development') {
    isOa = true;
}
const loginUrl =  `https://${isOa ? 'oa' : ''}admin.qidian.qq.com/ac/login`;
export default loginUrl;
